import Footer from "../components/Footer";

const Refund = () => {
  return (
    <div className="min-h-screen bg-background pt-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="mb-8">
          <span className="genre-badge text-primary border-primary mb-4 inline-block">
            LEGAL
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl font-black text-foreground">
            Refund Policy
          </h1>
          <p className="text-muted-foreground mt-2">Last updated: January 2025</p>
        </div>

        <div className="bg-card border border-border p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              All Sales Final
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Due to the nature of event tickets and travel bookings, all sales through XTrip are final. 
              Once a booking is confirmed and payment is processed, refunds are not available.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              Ticket Resale
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              If you cannot attend your booked event, you may be able to resell your tickets through 
              the official resale channels of the event organiser:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li><strong>Resident Advisor events:</strong> Use the RA Ticket Resale queue</li>
              <li><strong>Dice.fm events:</strong> Use the Dice Waiting List feature</li>
              <li><strong>Other events:</strong> Contact the venue or organiser directly</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              Event Cancellations
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              If an event is cancelled by the organiser, refunds will be processed according to the 
              organiser's refund policy. XTrip will assist in facilitating refunds where applicable, 
              but the final decision rests with the event organiser.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              Travel Components
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Flight and hotel cancellations are subject to the terms and conditions of the respective 
              travel providers. Refund eligibility depends on the fare type and booking conditions 
              selected at the time of purchase.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              Contact Us
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              For any questions regarding refunds or to discuss your specific booking, please contact{" "}
              <a 
                href="mailto:hello@xtriptour.com" 
                className="text-primary hover:underline"
              >
                hello@xtriptour.com
              </a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Refund;
